import config from '../config';
import { Password } from '@or-sdk/password';
import store from '../vuex/store';
export default new Password({
    sdkApiUrl: `${config.SDK_API_URL}`,
    token: () => store.state.auth.token,
});
